import { ApiViewAction } from './ApiViewModel'

export function refreshApiView(): ApiViewAction {
  return { type: 'REFRESH_API_VIEW' }
}
